import { FormControl } from '@material-ui/core';
import styled from 'styled-components';

export const Wrapper = styled(FormControl)`
  width: 100%;

  .MuiFormHelperText-root.Mui-error {
    margin-top: 0;
  }

  .__group {
    display: flex;
    align-items: center;
    justify-content: center;

    fieldset {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }

    button {
      background-color: rgba(0, 0, 0, 0.23);
      color: #fff;

      border-radius: 0;
      border-top-right-radius: 0.4rem;
      border-bottom-right-radius: 0.4rem;

      padding: 0.83rem;
    }
  }
`;
